import { Component, OnInit, NgModule, Injector, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { Constants } from 'src/app/util/Constants';
import { BaseComponent } from '../common/BaseComponent';

import { environment } from 'src/environments/environment';
import { ProgressService } from 'src/app/service/ProgressService';
import { CommonService } from 'src/app/service/CommonService';
import { PrefLangValidator } from 'src/app/validator/PrefLangValidator';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styles: [
  ]
})
export class ProfileComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;
  @ViewChild('profileForm') registerFormElement: ElementRef;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;

  pageMsgRendered : boolean;
  profileForm: FormGroup;
  restSub: Subscription;
  submitted: boolean;
  onLoad: boolean;
  updated: boolean;
  appUpdateSuccess: boolean;
  user: User;
  selectedOption: string = '';
  sessionUser: string;
  appErrorPrefix: string = "bss.profile.error";
  displayName: string;
  resourceUrl;
  backUrlExists: boolean = false;
  
  constructor(
    injector: Injector,
    public progressService: ProgressService,
    public rest: UserService, 
    public restCommon: CommonService) {
      super(injector);
      this.submitted = false;
      this.pageMsgRendered = false;
      this.onLoad = false;
      this.updated = false;
      this.appUpdateSuccess = false;
  }

  ngOnInit(): void {  
    /*const validRadioValues = ['en', 'fr'];
    // Custom validator function defined for checking preferred language
    const radioValueValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      //console.log(value);
      if (validRadioValues.indexOf(value) === -1) {
        //console.log('error');
        return { 'invalidRadioValue': { value } };
      }
      return null;
    };*/
    
    this.profileForm = new FormGroup({
      firstName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Constants.EF_NAME)])),
      middleName: new FormControl('',Validators.pattern(Constants.EF_NAME)),
      lastName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Constants.EF_NAME)])),
      displayName: new FormControl('', Validators.compose([Validators.required, Validators.pattern(Constants.EF_NAME)])),
      preferredLanguage: new FormControl('', Validators.compose([Validators.required, PrefLangValidator.checkValue]))
    });

    this.sessionUser = sessionStorage.getItem("user");
    this.user = JSON.parse(this.sessionUser);
    this.profileForm.patchValue(this.user);
    this.onLoad = true;

    console.log('landed on profile, isCertificateLogin: ', this.isCertificatelogin);    
    //do not need to fetch again, since it's done in AuthGuard
    //this.fetchData(this.user);

     // If backUrl is not null, then route the user to that page
     this.route.queryParams.subscribe(params => {
      const fullResourceUrl = (params['backUrl'])?.trim() ?? sessionStorage.getItem("backUrl");
      
      // if resource url received then search of the backUrl within this string
      if (fullResourceUrl) {
        var searchParams = new URLSearchParams(decodeURIComponent(fullResourceUrl));
        this.resourceUrl = decodeURIComponent(searchParams.get("backUrl"));
        if ( (this.resourceUrl ?? true) && this.resourceUrl == "null") {
          this.resourceUrl = fullResourceUrl;
        }
      } else {
        this.resourceUrl = null;
      }
      
      if (this.resourceUrl) {      
        sessionStorage.setItem("backUrl", this.resourceUrl);
        console.log("backUrl: [" + this.resourceUrl + "]");        

        // Determine whether the URL is white listed 
        this.restCommon.checkBackURL(this.resourceUrl).subscribe((response) => {         
          console.log("Profile - backURL:: response.result: " + response.result);
        //this.isSubmitting = false;
        if (response.result == 1) {
          console.log("Profile - backURL:: Invalid backURL : " + this.resourceUrl);
        }
        else if (response.result == 0) {
          this.appError = false;
          this.backUrlExists = true;          
        }
        else
          this.router.navigate(['public/error']);
        }, (error) => { 
          this.processError(error);        
        });
        //this.backUrlExists = true;      
      }
    });               
  }

    previousSite() {
    //this.router.navigateByUrl(this.resourceUrl);
    window.location.href = this.resourceUrl;
    }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  fetchData(user1: User) {
    console.log("Profile:: user.email: " + user1.email);

    this.restSub = this.rest.getUserInfo(user1).subscribe(response => {
      console.log("getUserInfo-Data:" + JSON.stringify(response));
      if (response.result == 1) {
        this.appError = true;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      } else {
        this.appError = false;
      }
      this.user = response;
      this.convertLanguage(this.user);
      this.user.email = response.email;

      console.log("In FetchData() user object: ", this.user);
      // Read JSON string into user object - 

      this.user.middleName = response.middleName !== null ? response.middleName : '';

      console.log(`User FirstName: ${this.user.firstName}`);
      console.log(`User middleName: ${this.user.middleName}`);
      console.log(`User LastName: ${this.user.lastName}`);
      console.log(`Preferred Language: ${this.user.preferredLanguage}`);

      this.profileForm.patchValue(this.user);

    }, (error) => { this.processError(error) });
  }

  updateDisplayName(firstName: string,  middleName: string, lastName: string) {
    if (middleName == null || middleName == '')
      this.displayName = `${firstName} ${lastName}`;
    else
      this.displayName = `${firstName} ${middleName} ${lastName}`;
    this.profileForm.controls['displayName'].setValue(this.displayName);
}

  changePassword() {
    console.log('Routing user to the change Password page: ', this.user.email);
    console.log('emailAccess: ', this.user.emailAccess);
    if(!this.user.emailAccess){
      this.router.navigate(['secure/user/reqemailupdate']);
    }else{
      this.router.navigate(['/secure/user/password/change']);
    }
    //sendEmailMFA -- MFA will be sent on loading of change Password page
    //this.sendOTPEmail(this.user.email);
    
  }

  viewRoles() {
    // Enable once the view Roles page is developed 
    console.log('Navigating to the view Roles  page: ', this.user);

    this.router.navigate(['/secure/user/roles']);
  }

  // Update User Profile Information
  updateInfo() {
    console.log('Update Info():: ', this.profileForm.value);

    this.submitted = true;
    this.appUpdateSuccess = false;
    this.pageMsgRendered = false;
    
    console.log('Update Information. Profile Valid: ', this.profileForm.valid);

    if (this.profileForm.valid) {
      //let user = new User();
      let user = JSON.parse(this.userSession);
      let pkiUser: boolean;
      this.isSubmitting = true;

      user.firstName = this.profileForm.get("firstName").value;
      user.middleName = this.profileForm.get("middleName").value;
      user.lastName = this.profileForm.get("lastName").value;
      user.displayName = this.profileForm.get("displayName").value;
      user.email = this.user.email;
      user.preferredLanguage = this.profileForm.get("preferredLanguage").value;
      pkiUser = user.pkiuser;
      console.log('Update Information. Before operation:: pkiuser: ', pkiUser);
      console.log('Update Information. Profile: ', this.profileForm.value);
      console.log('Updating Profile Information with the following User values: ', user);
      
      //sessionStorage.setItem("user", JSON.stringify(user));
      this.progressService.open();

      this.restSub = this.rest.updateUserInfo(user).subscribe(response => {
        console.log("Updating-UserInfo:" + JSON.stringify(response));
        this.isSubmitting = false;
        this.updated = true;
        if (response.result == 1) {
          this.appError = true;
          this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
        } else {
          this.appError = false;
          this.appUpdateSuccess = true;
          this.appSuccessMessage = this.getMessage('bss.profile.success.updateConfirmation');
          sessionStorage.setItem("currentLang", user.preferredLanguage);
          this.translator.use(user.preferredLanguage);
          user.pkiuser = pkiUser;
          console.log('Update Information. After operation:: pkiuser: ', user.pkiuser);
          sessionStorage.setItem("user", JSON.stringify(user));
        }
      }, (error) => {
        this.processError(error);
      },
      () => {
        this.progressService.close();
      }
      );

      console.log('updateInfo() :: Successfully updated Profile Information: ', user);
    }
  }

  updateEmail() {
    // Enable once a registration completed page is developed 
    // MFA will be sent on loading of update Email page
    console.log('Navigating to the email Update screen ', this.user);
    //this.sendOTPEmail(this.user.email);
    this.router.navigate(['/secure/user/email/update']);
  }


  sendOTPEmail(userEmail: string) {
    let user1 = new User;
    //user.email = '000566@ONTARIOEMAIL.CA';
    user1.email = userEmail;

    this.restSub = this.rest.sendEmailMFA(user1).subscribe(response => {
      console.log("sendEmailMFA:" + JSON.stringify(response));
      if (response.result == 1) {
        this.appError = true;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      } else {
        this.appError = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }
}
